module.exports = __webpack_public_path__ + "img/access4_gray.57baa275.png";